export class Usuario {
    username: string;
    password: string;
    codOficina: number;
    nomUsuario: string;
}
